import React, { useState } from 'react';
import css from './Sections.module.css';
import img1 from '../../../assets/curator1.png';
import img2 from '../../../assets/curator2.png';
import IconSearch from '../../../components/IconSearch/IconSearch';
import { FormattedMessage } from '../../../util/reactIntl';

function SectionSearch({ intl, useHistoryPush }) {
  const [searchTerm, setSearchTerm] = useState('');

  const curatorItems = [
    {
      title: 'OmeDezin',
      image: img1,
    },
    {
      title: 'Kelly Wearstler',
      image: img2,
    },
  ];

  const handleSearch = e => {
    if (e.key === 'Enter' && searchTerm.trim()) {
      useHistoryPush('SearchPage', {}, { keywords: searchTerm });
    }
  };

  return (
    <div className={css.searchSection}>
      <p>
        <FormattedMessage
          id="SectionShopByCurators.searchLabel"
          defaultMessage="OR, SEARCH FOR WHAT YOU’RE LOOKING FOR"
        />
      </p>
      <div className={css.searchInput}>
        <IconSearch />
        <input
          type="text"
          placeholder={intl.formatMessage({
            id: 'SectionShopByCurators.searchPlaceholder',
            defaultMessage: 'Type and press Enter...',
          })}
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          onKeyDown={handleSearch}
        />
      </div>
    </div>
  );
}

export default SectionSearch;
